export default __webpack_public_path__ + "images/banner-guy.fbf4f0f7396fe31ca288dc1dd9822342.png";